/* istanbul ignore file */
import LoginForm from './LoginForm'
import { connect } from 'react-redux'
import { login } from 'commons/js/services/login'
import { requestUser } from '../../actions/user'
import { updateKeycloakAuthToken } from '../../actions/token'
import { userIsLoadingSelector, userMailSelector } from '../../selectors/user'
import { trackGA4Event as track } from '../../actions/analytics'

function mapStateToProps (state) {
    return {
        email: userMailSelector(state),
        isLoading: userIsLoadingSelector(),
        login,
    }
}

function mapDispatchToProps (dispatch) {
    return {
        onLogin (token) {
            token && dispatch(updateKeycloakAuthToken(token))
            dispatch(requestUser())
        },
        trackEvent (event) {
            dispatch(track(event))
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginForm)
